import storage from "redux-persist/lib/storage";

export const userReducers = {
  LOG_OUT: (state) => {
    storage.removeItem("persist:root");
    state.userAuthToken = null;
    state.tokenData = null;
    state.loginData = null;
    state = null;
    window.location.reload();
    // localStorage.clear();
  },

  SET_AUTH: (state) => {
    state.userAuthToken = "this is a test";
  },
};
